import { MobileDevice } from 'graphql/generated/graphqlTypes';

export function generateMockMobileDevice({
  id = 'mockMobileDeviceId',
  isRegistered = true,
  registrationDate = null,
  registrationToken = null,
  role = 'ACCESS'
}: Partial<Omit<MobileDevice, '__typename'>>): MobileDevice {
  return {
    __typename: 'MobileDevice',
    id,
    isRegistered,
    registrationDate,
    registrationToken,
    role
  };
}
